<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 4484 4484"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="2242" cy="2242" r="2242"/>
     <g id="_807939336">
     <path class="fil1"
           d="M1873 1433c-74,0 -3,-9 -118,0 -41,4 -76,14 -107,24 -208,69 -336,257 -336,488 -168,0 -287,86 -352,216 -79,159 -49,346 76,471 26,27 58,48 91,65 16,9 -12,-6 9,5l8 4c37,17 94,31 149,31l1846 0c205,0 407,-178 454,-395 19,-85 18,-129 -1,-214 -7,-32 -18,-67 -30,-94 -26,-55 -59,-104 -100,-144 -54,-54 -85,-73 -154,-107l-30 -14c-57,-22 -119,-30 -182,-30 0,-165 -19,-292 -118,-425 -123,-168 -309,-268 -525,-268 -193,0 -387,101 -490,234 -30,38 -78,103 -90,153z"/>
       <path class="fil1"
             d="M2790 3429c0,87 107,127 161,61 24,-29 62,-172 75,-211 23,-68 88,-249 88,-311 0,-26 -14,-38 -29,-52 -39,-38 -97,-25 -125,3 -24,26 -170,498 -170,510z"/>
       <path class="fil1"
             d="M1861 3429c0,73 92,134 161,61 30,-32 100,-289 120,-347 23,-69 72,-163 20,-215 -41,-41 -99,-36 -131,-2 -26,26 -106,301 -124,356 -8,23 -46,132 -46,147z"/>
       <path class="fil1"
             d="M1399 3435c0,82 137,151 186,0 17,-50 30,-96 47,-147 14,-42 91,-272 91,-295 0,-98 -142,-154 -188,-1 -20,67 -136,405 -136,443z"/>
       <path class="fil1"
             d="M2328 3429c0,58 42,94 88,94 64,0 81,-39 97,-90 17,-51 31,-97 47,-147 16,-47 30,-95 47,-146 8,-26 46,-129 46,-147 0,-80 -104,-131 -161,-61 -24,29 -164,463 -164,497z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'RainDetector',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
